"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = void 0;
var store_1 = require("../store");
var user_1 = require("../user");
var utils_1 = require("../utils");
var create_context_1 = require("./functions/create-context");
var resolve_1 = require("./functions/resolve");
var dispatched_event_1 = require("./dispatched-event");
var event_factory_1 = require("./event-factory");
/**
 * Analytics code code
 */
var Analytics = /** @class */ (function () {
    function Analytics(settings, user) {
        var _a;
        this._initialized = false;
        this._context = {};
        this._settings = __assign(__assign({}, Analytics.defaults), settings);
        this._settings.timeout = (_a = this._settings.timeout) !== null && _a !== void 0 ? _a : 300;
        this._user =
            user !== null && user !== void 0 ? user : new user_1.User(__assign({}, this._settings.user)).load();
        this._context = (0, create_context_1.createContext)();
        this._eventFactory = new event_factory_1.EventFactory(this._user);
        this._initialized = true;
    }
    Object.defineProperty(Analytics, "defaults", {
        get: function () {
            return {
                enabled: true,
                path: '/events/collection',
                store: store_1.CombinedStore.defaults,
                user: user_1.User.defaults,
            };
        },
        enumerable: false,
        configurable: true
    });
    Analytics.prototype.track = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._settings.enabled) {
            return null;
        }
        var _a = __read(resolve_1.resolveArguments.apply(void 0, __spreadArray([], __read(args), false)), 3), name = _a[0], data = _a[1], opts = _a[2];
        var event = this._eventFactory.track(name, data, opts);
        return this.dispatch(event);
    };
    Analytics.prototype.page = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._settings.enabled) {
            return null;
        }
        var _a = __read(resolve_1.resolvePageArguments.apply(void 0, __spreadArray([], __read(args), false)), 4), category = _a[0], page = _a[1], properties = _a[2], options = _a[3];
        var event = this._eventFactory.page(category, page, properties, options);
        return this.dispatch(event);
    };
    Analytics.prototype.identify = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._settings.enabled) {
            return null;
        }
        var _a = __read((0, resolve_1.resolveUserArguments)(this._user).apply(void 0, __spreadArray([], __read(args), false)), 3), id = _a[0], userAttributes = _a[1], options = _a[2];
        this._user.identify(userAttributes, id);
        var event = this._eventFactory.identify(this._user.id(), this._user.attributes(), options);
        return this.dispatch(event);
    };
    Analytics.prototype.dispatch = function (event) {
        var dispatchedEvent = new dispatched_event_1.DispatchedEvent(event);
        // If no host is specified, use current server
        var host = this._settings.host || window.location.origin;
        var path = this._settings.path;
        if (host === undefined || host === null || path === undefined || path === null) {
            console.error('Stage TEN Analytics Host or Path not defined.');
            return dispatchedEvent;
        }
        if ((0, utils_1.isServer)() || (0, utils_1.isOffline)()) {
            return dispatchedEvent;
        }
        dispatchedEvent.log('debug', 'Dispatching');
        try {
            var wrapper = {
                apiKey: this._settings.apiKey,
                event: event,
            };
            var url = new URL(path, host);
            var body = JSON.stringify(wrapper);
            var blob = new Blob([body], { type: 'application/json; charset=UTF-8' });
            var sending = navigator.sendBeacon(url, blob);
            // (navigator.sendBeacon && navigator.sendBeacon(url, blob)) ||
            // fetch(url, {body: body, method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true })
            dispatchedEvent.log('debug', "Delivered: ".concat(sending));
        }
        catch (err) {
            dispatchedEvent.log('error', 'Failed to deliver', err);
            dispatchedEvent.setFailedDelivery(new dispatched_event_1.EventDeliveryFailedError(err));
        }
        return dispatchedEvent;
    };
    Analytics.prototype.ready = function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                callback();
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(Analytics.prototype, "initialized", {
        get: function () {
            return this._initialized;
        },
        enumerable: false,
        configurable: true
    });
    return Analytics;
}());
exports.Analytics = Analytics;
//# sourceMappingURL=analytics.js.map